
// DaisyUIのDropDownが開いた際に他の要素をくりっくできてしまう問題への対応
const overlayId = "select-overlay-blocker";

// オーバーレイ作成関数
const createOverlay = () => {
  let el = document.getElementById(overlayId);
  if (el) {
    return;
  }
  let ov = document.createElement("div");
  ov.id = overlayId;
  ov.style.position = "fixed";
  ov.style.top = "0";
  ov.style.left = "0";
  ov.style.width = "100vw";
  ov.style.height = "100vh";
  ov.style.zIndex = "9999";
  ov.style.background = "rgba(255, 1, 1, 0)"; // 完全透明
  ov.style.pointerEvents = "auto";

  document.body.appendChild(ov);
    // イベントハンドラー関数
    const handleEvent = (event) => {
      // popover要素をクリック/タップした場合は許可
      const popover = event.target.closest('[popover]');
      if (popover) {
        return; // popover内のクリック/タップは許可
      }
      // それ以外のクリック/タップは伝播を停止
      event.stopPropagation();
      event.preventDefault();
    };

    // クリックイベントのバブリングを抑制
    ov.addEventListener('click', handleEvent, true);
    // タッチイベントのバブリングを抑制（モバイル対応）
    ov.addEventListener('touchstart', handleEvent, true);
    ov.addEventListener('touchend', handleEvent, true);

    document.body.appendChild(ov);
};

// オーバーレイ削除
const removeOverlay = () => {
  const ov = document.getElementById(overlayId);
  if (ov) ov.remove();
};

// select要素にイベントリスナーを追加する関数
const setupSelectListeners = () => {
  document.querySelectorAll('[popover]').forEach(popover => {
    popover.addEventListener('toggle', (event) => {
      if (popover.matches(':popover-open')) {
        // popoverが開いた時
        createOverlay();
      } else {
        // popoverが閉じた時
        removeOverlay();
      }
    });
  });
};

// Turboで動的に追加されるselect要素にも対応
document.addEventListener("turbo:load", () => {
  setupSelectListeners();
});

// 初回読み込み時にも実行
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupSelectListeners);
} else {
  setupSelectListeners();
}

// MutationObserverで動的に追加されるselect要素にも対応
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // 追加された要素がselectかチェック
          if (node.matches && node.matches('select')) {
            setupSelectListeners();
          }
          // 子要素にselectがあるかチェック
          const selects = node.querySelectorAll && node.querySelectorAll('select');
          if (selects && selects.length > 0) {
            setupSelectListeners();
          }
        }
      });
    });
  });

  // DOMの変更を監視
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

